import React from 'react';
import { initials, avatarClass } from '../lib/format';

export default function UserAvatar({ nama = '', size = 40, className = '' }) {
  const cls = avatarClass(nama);
  return (
    <span
      className={`inline-flex items-center justify-center rounded-full font-bold select-none border shrink-0 ${cls} ${className}`}
      style={{ width: size, height: size, fontSize: size * 0.4 }}
      data-testid="user-avatar"
      aria-hidden
    >
      {initials(nama)}
    </span>
  );
}
